var _defs, _circle, _path, _g, _g2, _path2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1212.16,
    height: 719.21,
    viewBox: "0 0 1212.16 719.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 267,
    y1: 852.25,
    x2: 932.69,
    y2: 186.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fd8719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#cb00e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d90fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.93,
    y1: 491.36,
    x2: 409.46,
    y2: 491.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fd8719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cb00e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d90fef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 734.13,
    y1: 491.36,
    x2: 1099.66,
    y2: 491.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0043fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d90fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb00e3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.28,264.08h0a63.68,63.68,0,0,0-63.69,63.69v326a63.69,63.69,0,0,0,63.69,63.69h0A63.69,63.69,0,0,0,652,653.78v-326A63.68,63.68,0,0,0,588.28,264.08Zm-167,0h0A63.68,63.68,0,0,0,360.73,308a225.64,225.64,0,0,0-134-43.9C101.49,264.08,0,365.58,0,490.77s101.49,226.7,226.69,226.7a225.64,225.64,0,0,0,134-43.9,63.68,63.68,0,0,0,60.51,43.9h0a63.69,63.69,0,0,0,63.68-63.69v-326A63.68,63.68,0,0,0,421.24,264.08Zm-194.55,318A91.28,91.28,0,1,1,318,490.77,91.27,91.27,0,0,1,226.69,582.05Zm913.8,27.86-19.8-19.8a225.74,225.74,0,0,0,22.89-99.34c0-125.19-101.49-226.69-226.69-226.69S690.2,365.58,690.2,490.77s101.49,226.7,226.69,226.7a225.6,225.6,0,0,0,117.95-33.08L1050.42,700a63.69,63.69,0,0,0,90.07-90.07Zm-223.6-27.86a91.28,91.28,0,1,1,91.28-91.28A91.28,91.28,0,0,1,916.89,582.05Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 588.28,
    cy: 183.56,
    r: 63.13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 264.44,
    y1: 72.68,
    x2: 912.12,
    y2: 72.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d90fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043fc"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 588.28,
    cy: 183.56,
    r: 63.13,
    fill: "#da0fd4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M588.28,264.66h0a63.69,63.69,0,0,0-63.69,63.69v326a63.68,63.68,0,0,0,63.69,63.69h0A63.68,63.68,0,0,0,652,654.36v-326A63.69,63.69,0,0,0,588.28,264.66Zm-167,0h0a63.68,63.68,0,0,0-60.51,43.9,225.64,225.64,0,0,0-134-43.9C101.49,264.66,0,366.16,0,491.36S101.49,718.05,226.69,718.05a225.64,225.64,0,0,0,134-43.9,63.68,63.68,0,0,0,60.51,43.9h0a63.68,63.68,0,0,0,63.68-63.69v-326A63.69,63.69,0,0,0,421.24,264.66Zm-194.55,318A91.28,91.28,0,1,1,318,491.36,91.27,91.27,0,0,1,226.69,582.63Zm913.8,27.86-19.8-19.8a225.73,225.73,0,0,0,22.89-99.33c0-125.2-101.49-226.7-226.69-226.7S690.2,366.16,690.2,491.36,791.69,718.05,916.89,718.05A225.6,225.6,0,0,0,1034.84,685l15.58,15.59a63.69,63.69,0,0,0,90.07-90.07Zm-223.6-27.86a91.28,91.28,0,1,1,91.28-91.27A91.27,91.27,0,0,1,916.89,582.63Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M588.28,679.52a25.18,25.18,0,0,1-25.16-25.16v-326a25.16,25.16,0,0,1,50.32,0v326A25.19,25.19,0,0,1,588.28,679.52Z",
    fill: "#ac33fd",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.69,308.59c-100.93,0-182.76,81.83-182.76,182.77s81.83,182.76,182.76,182.76,182.77-81.83,182.77-182.76A182.77,182.77,0,0,0,226.69,308.59Zm0,274A91.28,91.28,0,1,1,318,491.36,91.27,91.27,0,0,1,226.69,582.63Z",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.89,308.59c-100.94,0-182.76,81.83-182.76,182.77A182.76,182.76,0,0,0,916.89,674.12c100.94,0,182.77-81.83,182.77-182.76A182.77,182.77,0,0,0,916.89,308.59Zm0,274a91.28,91.28,0,1,1,91.28-91.27A91.27,91.27,0,0,1,916.89,582.63Z",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.28,
    cy: 183.56,
    r: 35.57,
    fill: "#ac33fd",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 851.03,
    cy: 427.06,
    r: 195.81,
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.03,
    cy: 427.06,
    r: 91.04,
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 916.89,
    cy: 491.36,
    r: 103.86,
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.69,
    cy: 491.36,
    r: 103.86,
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.51,
    cy: 430.77,
    r: 195.81,
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.51,
    cy: 430.77,
    r: 91.16,
    fill: "#fff",
    opacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 570.38,
    cy: 169.61,
    r: 58.54,
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.58,
    cy: 161.51,
    r: 35.57,
    fill: "#fff",
    opacity: 0.1
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M879.23,144.19c-48.74-33.59-96-52.24-144.38-65.45a617.57,617.57,0,0,0-146.57-18c-49.19.36-98.19,5.24-146.64,17.91C393.21,91.79,346,110.53,297.33,144.19l-.94.64a2.93,2.93,0,0,1-4.13-4C323,92.68,370.52,57,422.47,34.37,474.56,11.47,531.48.56,588.28,0,645.08.54,702,11.46,754.09,34.37,806,57,853.55,92.67,884.3,140.85a2.93,2.93,0,0,1-4.13,4Z",
    fill: "url(#linear-gradient-4)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1208.8,569.06a24.41,24.41,0,0,0-9.31-9.44,26.45,26.45,0,0,0-13.44-3.43,26.76,26.76,0,0,0-13.58,3.43,24.55,24.55,0,0,0-9.31,9.44,27.19,27.19,0,0,0-3.36,13.51,27.55,27.55,0,0,0,3.36,13.57,24.37,24.37,0,0,0,9.31,9.5,26.66,26.66,0,0,0,13.58,3.43,26.35,26.35,0,0,0,13.44-3.43,24.23,24.23,0,0,0,9.31-9.5,27.55,27.55,0,0,0,3.36-13.57A27.19,27.19,0,0,0,1208.8,569.06Zm-18.1,27.21-6.2-10.34h-2.2v10.34h-6.72V568.48H1188a10.27,10.27,0,0,1,7,2.32,8,8,0,0,1,2.65,6.34,8.44,8.44,0,0,1-1.61,5.23,8.71,8.71,0,0,1-4.46,3l7.24,10.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190,575.26a3.94,3.94,0,0,0-2.39-.71h-5.3v5.82h5.3a3.67,3.67,0,0,0,2.39-.78,2.62,2.62,0,0,0,1-2.19A2.48,2.48,0,0,0,1190,575.26Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiqLogo);
export default __webpack_public_path__ + "static/media/Aiq_Logo.6aaacf0b0c5fcc9a5dbf8ce72b2e31f5.svg";
export { ForwardRef as ReactComponent };